// Stacked horizontal bars — a column stacks its children, so the bars are the children.
export function ArrangeColumnIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M2 0.5H12A1.5 1.5 0 0 1 13.5 2V5A1.5 1.5 0 0 1 12 6.5H2A1.5 1.5 0 0 1 0.5 5V2A1.5 1.5 0 0 1 2 0.5ZM2 1.5H12A0.5 0.5 0 0 1 12.5 2V5A0.5 0.5 0 0 1 12 5.5H2A0.5 0.5 0 0 1 1.5 5V2A0.5 0.5 0 0 1 2 1.5ZM2 7.5H12A1.5 1.5 0 0 1 13.5 9V12A1.5 1.5 0 0 1 12 13.5H2A1.5 1.5 0 0 1 0.5 12V9A1.5 1.5 0 0 1 2 7.5ZM2 8.5H12A0.5 0.5 0 0 1 12.5 9V12A0.5 0.5 0 0 1 12 12.5H2A0.5 0.5 0 0 1 1.5 12V9A0.5 0.5 0 0 1 2 8.5Z"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
